import React from "react";
import "./LoginPage.styles.scss";
import Login from "../../components/Login/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
